<template>
  <div class="mt-4 position-relative">
    <div v-if="dispatchingOrder" class="overlay">
      <ClimbingLeaf style="top: 200px; position: relative" />
    </div>
    <BushelCard body-class="p-0 bg-transparent" header-class="cart-group-header bg-primary text-white">
      <template #header>
        <div class="cart-group-title d-flex">
          <span class="m-auto" style="font-size: 31px">
            {{ sellerCompanyName }}
          </span>
          <span v-if="groupCount > 1" class="circle-number border border-white ml-2">{{ groupNumber + 1 }}</span>
          <BushelBtn class="ml-2" flat variant="light" @click="showingDetails = !showingDetails">
            <i :class="showingDetails ? 'fa fa-chevron-down' : 'fa fa-chevron-up'" />
          </BushelBtn>
        </div>
      </template>
      <template v-if="orderType" #headerButtons>
        <div class="badge px-3 py-2 mr-3 custom-badge">
          {{ orderType }}
        </div>
      </template>
      <div v-if="minimum" class="alert alert-warning m-4">
        <div v-if="minimum.type == 'total'">
          Required minimum order of
          {{ currency(minimum.minimum) }}
        </div>
        <div v-else>
          Minimums Not Met
          <div v-for="m in minimum.failedCategories" :key="m.id">{{ m.category.name }}: {{ currency(m.price) }}</div>
        </div>
      </div>
      <div v-else-if="sellerOperation.shipping_free && !isTheSeller" class="alert alert-success m-4 text-center">
        <div>
          This location offers free shipping
          <span v-if="sellerOperation.shipping_free_value">
            on orders over
            {{ currency(sellerOperation.shipping_free_value) }}
          </span>
          <span v-if="sellerOperation.shipping_free_distance">
            <span>
              within
              {{ sellerOperation.shipping_free_distance }}
              miles of
              {{
                `${sellerOperation.line_one} ${sellerOperation.city} ${sellerOperation.state ? sellerOperation.state.text : ""} ${
                  sellerOperation.country ? sellerOperation.country.text : ""
                }`
              }}
            </span>
          </span>
          <br />
          <div v-if="anyTotalAboveFreeShipping">Request free shipping if you meet the requirements</div>
        </div>
      </div>
      <div>
        <CartGroup
          :showing-details="showingDetails"
          :buyer="buyer"
          :is-the-seller="isTheSeller"
          :us-cannabis-user="usCannabisUser"
          :seller-operation="sellerOperation"
          :submitted="submitted"
          :order-details="orderDetails"
          :group="group"
          :seller-company-name="sellerCompanyName"
          @remove-from-cart="(val) => $emit('removeFromCart', val)"
          @update-field-in-group="(val) => $emit('updateFieldInGroup', val)"
          @handle-update-quantity="(val) => $emit('handleUpdateQuantity', val)"
          @adjust-to-max-quantity-in-cart="(val) => $emit('adjustToMaxQuantityInCart', val)"
        />
      </div>
    </BushelCard>
  </div>
</template>
<script>
import CartGroup from "./CartGroup.vue";
import ClimbingLeaf from "@/components/common/loaders/ClimbingLeaf.vue";
import { currency } from "@/services/filters";

export default {
  components: { CartGroup, ClimbingLeaf },
  props: {
    dispatchingOrder: { type: Boolean, required: true },
    usCannabisUser: { type: Boolean, required: true },
    cartItems: { type: Array, required: true },
    group: { type: Object, required: true },
    sellerCompanyName: { type: String, required: true },
    usedOnMarketplace: { type: Boolean, default: false },
    cartMinimums: { type: Object, required: true },
    buyer: { type: Object, required: true },
    submitted: { type: Boolean, required: true },
    isTheSeller: { type: Boolean, required: true },
    groupNumber: { type: Number, required: true },
    groupCount: { type: Number, required: true },
    sellerOperation: { type: Object, required: true },
    isSuggestedCart: { type: Boolean, required: false },
    orderDetails: { type: Object, required: true },
  },
  emits: ["removeFromCart", "updateFieldInGroup", "handleUpdateQuantity", "adjustToMaxQuantityInCart"],
  data() {
    return {
      showingDetails: false,
    };
  },
  computed: {
    anyTotalAboveFreeShipping() {
      const accumulatedTotal = this.group.items.reduce((accumulator, item) => accumulator + item.finalPrice, 0);

      if (accumulatedTotal > this.sellerOperation.shipping_free_value) {
        return true;
      }
      return false;
    },
    minimum() {
      const opId = this.sellerOperation.id;
      return this.cartMinimums[opId];
    },
    orderType() {
      if (this.group.subtype == "backorder") {
        return "PRE-ORDER";
      }
      if (this.group.subtype == "standard") {
        return "ORDER";
      }
      return "";
    },
  },
  created() {},

  methods: {
    currency,
  },
};
</script>

<style scoped>
:deep(.cart-group-header) {
  border-bottom: 1px solid #ccc;
}

.overlay {
  position: absolute;
  z-index: 1;
  background: rgba(0, 0, 0, 0.6); /* Black see-through */
  color: #f1f1f1;
  width: 100%;
  height: 100%;
  transition: 0.5s ease;
  border-radius: 0.16rem;

  /* opacity:0; */
  color: white;
  font-size: 20px;
  padding: 20px;
  text-align: center;
}

.cart-group-title {
  padding: 1rem;
  white-space: normal !important;
}

.custom-badge {
  letter-spacing: 3px;
  font-weight: 200;
  font-size: 20px;
}

.circle-number {
  height: 45px;
  width: 45px;
  line-height: 45px;
  -moz-border-radius: 30px;
  border-radius: 30px;
  color: white;
  text-align: center;
  font-size: 2em;
}
</style>
